import React from 'react'

import { LoadMore } from '../details/collection'

import IssueHistoryCardContainer from '../../containers/issue-histories/issue-history-card-container'

export default ({
  histories,
  hasNextPage,
  onLoadNextPage
}) => (
  <div className='list area-activity'>
    {histories.length
      ? histories.map(history => <IssueHistoryCardContainer history={history} key={history.id} />)
      : <p className='no-content'>This issue hasn't seen any activity.</p>}

    <LoadMore hasNextPage={hasNextPage} onLoadNextPage={onLoadNextPage} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/issue-histories/issue-histories-list.js